import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withPropsOnChange, withState } from 'recompose';
import { fetchMatches, resetMatches } from '../../../reducer/actions';
import { MIN_PAGINATION_ITEMS } from '../constants';
import { getShopBrandId } from '../../../../../../auth/selectors';
import MatchesTableInfinityScroll from './MatchesTableInfinityScroll';
import { getMatchesInitializeStatus } from '../../../selectors';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  count: state.shopify.shopifyMatches.pagination.count,
  list: state.shopify.shopifyMatches.list,
  loadingMatches: state.shopify.shopifyMatches.loading,
  shopifySettings: state.shopify.shopifySettings.settings,
  page: state.shopify.shopifyMatches.pagination.page,
  matchesInitialized: getMatchesInitializeStatus(state),
});

const mapDispatchToProps = {
  fetchMatches,
  resetMatches,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('matches', 'setMatches', []),
  withProps(props => ({
    hasMoreMatches: props.page * MIN_PAGINATION_ITEMS < props.count,
  })),
  withPropsOnChange(['matchesFromServer'], (props) => {
    props.setMatches([
      ...props.matches,
      ...props.matchesFromServer
        .filter(matchFromServer => !props.matches
          .some(localMatch => localMatch.id === matchFromServer.id)),
    ]);
  }),
  withHandlers({
    loadMoreMatches: props => () => {
      if (props.loadingMatches) {
        return;
      }

      props.fetchMatches(props.brandId, props.shopifySettings, props.status, MIN_PAGINATION_ITEMS, props.page + 1);
    },
  }),
)(MatchesTableInfinityScroll);
